
export const CREATE_VENDOR_MANAGEMENT_FORM = 'CREATE_VENDOR_MANAGEMENT_FORM';

export const CREATE_VENDOR_MANAGEMENT_REQUEST = 'CREATE_VENDOR_MANAGEMENT_REQUEST';
export const CREATE_VENDOR_MANAGEMENT_SUCCESS = 'CREATE_VENDOR_MANAGEMENT_SUCCESS';
export const CREATE_VENDOR_MANAGEMENT_FAILURE = 'CREATE_VENDOR_MANAGEMENT_FAILURE';

export const VENDOR_MANAGEMENT_FORM_RESET = 'VENDOR_MANAGEMENT_FORM_RESET';

export const SET_PROGRAM_NAME_VENDOR_MANAGEMENT = "SET_PROGRAM_NAME_VENDOR_MANAGEMENT";